export default "/_next/static/images/service-furmacy-desktop-626294ede0441900d6d79ffb46d81b28.jpeg";